module.exports = __webpack_public_path__ + "static/media/web-app2.d9f0a067.jpg";